import { withMonitoring } from '../../monitoring/withMonitoring'
import { httpClient } from '../httpClient'

export const sendEmailToUser = async (emailTemplateName: string, templateParams?: any) => {
  const request = () => httpClient.post('/send-email', { emailTemplateName, templateParams })

  withMonitoring(request, 'sendEmail')
}
